var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwemojiFlagNigeria(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5408_44993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 3.33334C1.95942 3.33334 1.28115 3.61429 0.781049 4.11439C0.280952 4.61449 0 5.29277 0 6.00001L0 18C0 18.7073 0.280952 19.3855 0.781049 19.8856C1.28115 20.3857 1.95942 20.6667 2.66667 20.6667H8V3.33334H2.66667Z",
    fill: "#009A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.33334H16V20.6667H8V3.33334Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 3.33334H16V20.6667H21.3333C22.0406 20.6667 22.7189 20.3857 23.219 19.8856C23.719 19.3855 24 18.7073 24 18V6.00001C24 5.29277 23.719 4.61449 23.219 4.11439C22.7189 3.61429 22.0406 3.33334 21.3333 3.33334Z",
    fill: "#009A49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5408_44993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwemojiFlagNigeria);
export default __webpack_public_path__ + "static/media/twemoji_flag-nigeria.43f65143e4047ea5288826ee3433938b.svg";
export { ForwardRef as ReactComponent };